import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Layout } from './components/layout/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { HomePage } from './pages/HomePage';
import { MarketplacePage } from './pages/MarketplacePage';
import { ProductPage } from './pages/ProductPage';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { CategoriesPage } from './pages/CategoriesPage';
import { SectorsPage } from './pages/SectorsPage';
import { PurchaseSuccessPage } from './pages/PurchaseSuccessPage';
import { SellPage } from './pages/SellPage';
import { SellerProfilePage } from './pages/SellerProfilePage';
import { SellerOnboardingPage } from './pages/SellerOnboardingPage';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public routes without Layout */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          
          {/* Public routes with Layout */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/marketplace" element={<Layout><MarketplacePage /></Layout>} />
          <Route path="/categories" element={<Layout><CategoriesPage /></Layout>} />
          <Route path="/sectors" element={<Layout><SectorsPage /></Layout>} />
          <Route path="/product/:id" element={<Layout><ProductPage /></Layout>} />
          <Route path="/seller/:sellerId" element={<Layout><SellerProfilePage /></Layout>} />
          <Route path="/purchase/success" element={<Layout><PurchaseSuccessPage /></Layout>} />
          <Route 
            path="/sell" 
            element={
              <Layout>
                <ProtectedRoute>
                  <SellPage />
                </ProtectedRoute>
              </Layout>
            } 
          />
          
          {/* Protected routes with Layout */}
          <Route 
            path="/dashboard" 
            element={
              <Layout>
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              </Layout>
            } 
          />
          <Route 
            path="/seller/onboarding" 
            element={
              <Layout>
                <ProtectedRoute>
                  <SellerOnboardingPage />
                </ProtectedRoute>
              </Layout>
            } 
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;